import React, { useState } from 'react';
import { Info, X } from 'lucide-react';
import { useDropzone, FileWithPath } from 'react-dropzone';
import CustomModal from "../../components/CustomModal";

const VirtualAssistantModals = ({
  showBuildModal,
  setShowBuildModal,
  showImportModal,
  setShowImportModal,
  handleImport,
  customModal,
  setCustomModal
}: any) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const handleFileChange = (acceptedFiles: FileWithPath[]) => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      if (file.type === 'application/json') {
        setSelectedFile(file);
      } else {
        setCustomModal({
          isOpen: true,
          title: "Invalid File Type",
          message: "Please select a .json file.",
          type: "error",
        });
        setSelectedFile(null);
      }
    }
  };

  const handleImportClick = async () => {
    const success = await handleImport(selectedFile);
    if (success) {
      setShowImportModal(false);
    }
  };

  const ImportModal = () => {
    const { getRootProps, getInputProps, isDragActive, fileRejections } = useDropzone({
      onDrop: handleFileChange,
      multiple: false,
      accept: {
        'application/json': ['.json'],
      },
    });

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
        <div className="bg-white rounded-lg w-full max-w-md mx-4">
          <div className="flex justify-between items-center p-6 border-b border-gray-200">
            <h2 className=" text-xl font-semibold">Import Chatbot</h2>
            <button
              onClick={() => setShowImportModal(false)}
              className="text-gray-500 hover:text-gray-700"
            >
              <X className="h-5 w-5" />
            </button>
          </div>

          <div className="p-6">
            <div
              {...getRootProps()}
              className={`dropzone w-full h-36 border-2 border-dashed rounded-lg flex items-center justify-center cursor-pointer transition-colors
               ${isDragActive ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:border-gray-400'}
               ${fileRejections.length > 0 ? 'border-red-500' : ''}`}
            >
              <input {...getInputProps()} />
              <div className="text-center p-4">
                {isDragActive ? (
                  <p className="text-blue-600">Drop the file here</p>
                ) : (
                  <div className="space-y-2">
                    <p className="text-gray-600">Drag and drop a JSON file here, or click to select a file</p>
                    {fileRejections.length > 0 && (
                      <p className="text-sm text-red-500">
                        Invalid file type. Please select a .json file.
                      </p>
                    )}
                  </div>
                )}
              </div>
            </div>

            {selectedFile ? (
              <div className="mt-4">
                <p>Selected File: {selectedFile.name}</p>
                <a
                  href={URL.createObjectURL(selectedFile)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 underline"
                >
                  View File
                </a>
              </div>
            ) : (
              <p className="mt-4">No file chosen</p>
            )}

            <div className="mt-8 flex justify-end gap-4">
              <button
                onClick={() => setShowImportModal(false)}
                className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={handleImportClick}
                className="save-button px-4 py-2 rounded-md "
                disabled={!selectedFile}
              >
                Import
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const BuildModal = () => (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg w-full max-w-7xl mx-4">
        <div className="flex justify-between items-center p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold">Build New Chatbot</h2>
          <button
            onClick={() => setShowBuildModal(false)}
            className="text-gray-500 hover:text-gray-700"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="p-6">
          <div className="bg-gray-50 border border-gray-200 rounded-md p-4 mb-6">
            <div className="flex items-start gap-2">
              <Info className="h-5 w-5 text-gray-500 mt-0.5" />
              <p className="text-sm text-gray-600">
                Coming Soon!
              </p>
            </div>
          </div>

          <div className="mt-8 flex justify-end gap-4">
            <button
              onClick={() => setShowBuildModal(false)}
              className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {/* Custom Modal */}
      <CustomModal
        isOpen={customModal.isOpen}
        onClose={() => setCustomModal({ ...customModal, isOpen: false })}
        onConfirm={customModal.onConfirm}
        title={customModal.title}
        message={customModal.message}
        type={customModal.type}
      />
      
      {/* Build Modal */}
      {showBuildModal && <BuildModal />}
      
      {/* Import Modal */}
      {showImportModal && <ImportModal />}
    </>
  );
};

export default VirtualAssistantModals;